import { Flex, useDisclosure } from '@chakra-ui/react';
import { FC, useState } from 'react';

import PaginationContentWrap from 'presentation/components/shared/pagination/PaginationContentWrap';
import { PeOrderListItem } from 'model/modules/pe/orders/peOrderList';
import PeSelfOrdersGridItem from './PeSelfOrderGridItem';
import CancelPeOrderModal from 'presentation/containers/modules/pe/modals/CancelPeOrderModal';

interface Props extends PaginationListProps<PeOrderListItem> {}

const PeSelfOrdersGrid: FC<Props> = ({
  items,
  isFetching,
  setPage,
  currentPage,
  pageCount,
}) => {
  const gapBetweenCards = 20;

  const { isOpen, onOpen, onClose } = useDisclosure();

  const [selectedItem, setSelectedItem] = useState<PeOrderListItem | null>(
    null
  );

  return (
    <>
      <PaginationContentWrap
        itemsCount={items.length}
        isFetching={isFetching}
        setPage={setPage}
        currentPage={currentPage}
        pageCount={pageCount}
      >
        <Flex flexWrap="wrap" justifyContent="space-between">
          {items.map((order) => (
            <PeSelfOrdersGridItem
              key={order.id}
              peOrder={order}
              w={`calc(50% - ${gapBetweenCards / 2}px)`}
              mb={`${gapBetweenCards}px}`}
              onCancelClick={() => {
                setSelectedItem(order);
                onOpen();
              }}
            />
          ))}
        </Flex>
      </PaginationContentWrap>
      {selectedItem && (
        <CancelPeOrderModal
          isOpen={isOpen}
          onClose={onClose}
          orderId={selectedItem.id}
        />
      )}
    </>
  );
};

export default PeSelfOrdersGrid;
